import * as React from "react";
import * as Howler from "howler";
import { IAppState } from "./App";
import { IThemeText } from "./Scenario";

export interface IThemeTextProps {
    appState: IAppState;
    themeText: IThemeText;
}
interface IThemeTextState {
    textIndex: number;
}
export class ThemeTextComponent extends React.Component<IThemeTextProps, IThemeTextState> {
    constructor(props: IThemeTextProps) {
        super(props);
        this.state = { textIndex: 0 };
        this.textDiv = React.createRef();
        this.typewriterSound = new Howler.Howl({
            src: ["/sound/keypress.mp3"],
            volume: 0.2,
            loop: false
        });
    }
    componentDidUpdate(): void {
        this.startTypewriter();
    }
    startTypewriter() {
        ////var $textDiv = $(this.textDiv);
        //var i = 0;
        //var self = this;
        //var options = {
        //    strings: ["My message"],
        //    typeSpeed: 5,
        //    backDelay: 0,
        //    onComplete: () => {
        //        alert("what");
        //    },
        //    onStringTyped: ()=> {
        //        i++;
        //        if (!(i % 2)) { //don't play on every char (get too chatty)
        //            self.typewriterSound.stop();
        //            self.typewriterSound.play();
        //        }
        //    }
        //};
        //var typed = new Typed(this.textDiv, options);
    }
    componentDidMount(): void {
        this.startTypewriter();
    }

    render() {
        const text = this.props.themeText.texts.map((t, i) => <p key={i}>{t}</p>);
        
        const buttons = this.props.themeText.actions.map((a, i) => {
            return (<button key={i} onClick={() => a.action(this.props.appState)}>{a.title}</button>);
        });
        return (
            <div className="container">
                <div className="col-md-12 p-t-30">
                    <div id="themeText">
                        <div className="content-box">
                            <h1>{this.props.themeText.title}</h1>
                            <div ref={this.textDiv} className="typewriter-text">{text}</div>
                            <div className="clearfix">
                                <div className="pull-right">
                                    {buttons}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    textDiv: any;
    typewriterSound: Howl;
}
